import { ConnectivityStatusType } from '~/common/models/common.model';
import type {
  ApiConnectivityStatusSummary,
  ApiVehicleStatusSummaryV20260602,
  ConnectivityStatusSummary,
} from '~/common/models/csDashboard.model';
import { mapConnectivityStatusType } from '~/features/assets/mappers/asset.mappers';

export const mapConnectivityStatusSummary = (
  data: ApiConnectivityStatusSummary,
  isNotEquippedFeatureFlag?: boolean
): ConnectivityStatusSummary => {
  let verificationPending = 0;
  let verified = 0;
  let connectionPending = 0;
  let connected = 0;
  let notEquipped = 0;

  for (const item of data?.items ?? []) {
    const status = mapConnectivityStatusType({
      organizationOwnershipStatus: item?.organizationPrimaryOwnershipStatus,
      onStarConnectionStatus: item?.connectionStatus,
      onstarSupportStatus: item?.onStarSupportStatus,
      isNotEquippedFeatureFlag: isNotEquippedFeatureFlag ?? false,
      isNewConnectivityStatusFeatureFlag: false,
    });
    switch (status) {
      case ConnectivityStatusType.VERIFICATION_PENDING:
        verificationPending++;
        break;
      case ConnectivityStatusType.VERIFIED:
        verified++;
        break;
      case ConnectivityStatusType.CONNECTION_PENDING:
        connectionPending++;
        break;
      case ConnectivityStatusType.CONNECTED:
        connected++;
        break;
      case ConnectivityStatusType.NOT_EQUIPPED:
        notEquipped++;
        break;
    }
  }
  return {
    organizationId: data.organizationId,
    totalVehicleCount: data.totalVehicleCount,
    connectivityStatuses: {
      verified,
      verificationPending,
      notEquipped,
      connectionPending,
      connected,
    },
  };
};

/**
 * Maps the V20260602 vehicle status dashboard summary API response to UI counts.
 * The endpoint returns per-status counts directly; verified is not returned.
 */
export const mapVehicleStatusSummaryV20260602 = (
  data: ApiVehicleStatusSummaryV20260602,
  organizationId: string
): ConnectivityStatusSummary => {
  const verificationPending = data.verificationPending ?? 0;
  const notEquipped = data.notEquipped ?? 0;
  const connectionPending = data.connectionPending ?? 0;
  const connected = data.connected ?? 0;

  return {
    organizationId,
    totalVehicleCount:
      verificationPending + notEquipped + connectionPending + connected,
    connectivityStatuses: {
      verificationPending,
      notEquipped,
      connectionPending,
      connected,
    },
  };
};
